import { createFileRoute, redirect } from '@tanstack/react-router';

// Usage moved out from under Settings to its own top-level route at
// /$organizationName/usage. This redirect preserves bookmarks and the
// in-app link target prior to the move.
export const Route = createFileRoute('/$organizationName/settings/usage')({
  component: () => null,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$organizationName/usage',
      params,
      search: search as any,
    });
  },
});
